import { useState } from "react";
import {
  TransferCategory,
  TransferCreate,
  TransferService,
} from "@/domains/transfer";
// components
import { Button, Divider, Form, Input } from "antd";

export const TenantManageCreateMemberDepositPage = () => {
  const [loading, setLoading] = useState(false);

  const [resTargetAddress, setResTargetAddress] = useState("");

  const handleFinish = async (values: TransferCreate) => {
    const data = {
      ...values,
      currency: "USDT",
    };

    try {
      setLoading(true);
      const res = await TransferService.create({
        ...data,
        category: TransferCategory.MemberDeposit,
        currency: "USDT",
      }).run();
      const address = res.data.msg.transfer.target?.address;
      address && setResTargetAddress(address);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setResTargetAddress("");
  };

  return (
    <div className="w:500 p:16 bg:white r:4 mt:0 mb:0 ml:auto mr:auto">
      <h4 className="mb:24 t:center fg:secondary">申請會員代收</h4>

      <Form
        labelCol={{ span: 5 }}
        onFinish={handleFinish}
        onReset={handleReset}
      >
        <Form.Item
          label="存單金額"
          name="amount"
          rules={[{ required: true, message: "存單金額不可空白" }]}
        >
          <Input type="number" placeholder="請輸入存單金額" />
        </Form.Item>

        <Form.Item
          label="平台單號"
          name={["order", "id"]}
          rules={[{ required: true, message: "平台單號不可空白" }]}
        >
          <Input placeholder="請輸入平台單號" />
        </Form.Item>

        <Form.Item label="會員代碼" name={["member", "id"]}>
          <Input placeholder="請輸入會員代碼" />
        </Form.Item>

        <Form.Item label="會員帳號" name={["member", "username"]}>
          <Input placeholder="請輸入會員帳號" />
        </Form.Item>

        <Form.Item label="會員名稱" name={["member", "name"]}>
          <Input placeholder="請輸入會員名稱" />
        </Form.Item>

        <Form.Item label="備註" name="note">
          <Input placeholder="請輸入備註" />
        </Form.Item>

        <div className="flex jc:center gap:16">
          <Button type="primary" htmlType="submit" loading={loading}>
            送出
          </Button>

          <Button htmlType="reset">清除</Button>
        </div>

        {resTargetAddress && (
          <>
            <Divider />

            <Form.Item label="收款地址">
              <Input readOnly value={resTargetAddress} />
            </Form.Item>
          </>
        )}
      </Form>
    </div>
  );
};
